// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D1vBtGT","breadcrumbs":"_5D1aL-DK","header":"_5D2lkA46"};